var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"primary","disabled":!_vm.isDraft,"loading":_vm.submitCraftRecordLoading,"icon":"el-icon-upload2","size":"mini"},on:{"click":_vm.submitCraftRecord}},[_vm._v("提交 ")])}
var staticRenderFns = []

export { render, staticRenderFns }